import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Swatch from './Swatch'
import partition from 'lodash/partition'

const FontPicker = (props) => (
  <select {...props}>
    <option value="'Helvetica Neue', 'Roboto', 'Helvetica', 'Arial', sans-serif">
      Helvetica Neue, Roboto, Helvetica, Arial, sans-serif
    </option>
    <option value="'Libre Franklin', sans-serif">
      Libre Franklin, sans-serif
    </option>
    <option value="'Cormorant', serif">
      Cormorant, serif
    </option>
    <option value="'Fira Sans', sans-serif">
      Fira Sans, sans-serif
    </option>
  </select>
)

export default class SwatchGroup extends Component {
  static propTypes = {
    prefix: PropTypes.string.isRequired,
    swatches: PropTypes.object.isRequired,
    labels: PropTypes.object
  }

  static defaultProps = {
    labels: {
      background: 'Background',
      color: 'Text Color',
      fontFamily: 'Font'
    }
  }

  state = {
    style: this.props.swatches
  }

  handleChange = (key, val) => {
    const { style } = this.state
    style[key] = val
    this.setState({ style })
  }

  renderPreview() {
    const element = this.props.children && React.Children.only(this.props.children)
    if (element) {
      const { style={} } = element.props
      return React.cloneElement(element, {
        ...element.props,
        style: { ...style, ...this.state.style }
      })
    }
  }

  renderSwatches() {
    const { swatches:fields, labels, prefix } = this.props
    const [fonts, swatches] = partition(Object.keys(fields), field => {
      return field.match(/font/i)
    })
    return [
      ...swatches.map(key => (
        <Swatch
          key={key}
          label={labels[key] || key}
          name={`${prefix}[${key}]`}
          defaultColor={fields[key]}
          onChange={val => this.handleChange(key, val)} />
      )),
      ...fonts.map(key => (
        <FontPicker
          key={key}
          name={`${prefix}[${key}]`}
          defaultValue={fields[key]}
          onChange={({target:{value}}) => this.handleChange(key, value)} />
      ))
    ]
  }

  render() {
    return (
      <div className="swatch-group">
        {this.renderSwatches()}
        {this.renderPreview()}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// client/components/sections/website/settings/Design/SwatchGroup.js